"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.initialAuthState = void 0;
var initialAuthState = {
  isAuthenticated: false,
  isLoading: true,
  token: '',
  user: {}
};
exports.initialAuthState = initialAuthState;